// reCAPTCHA Configuration
// This file contains the configuration for Google reCAPTCHA

// reCAPTCHA site keys (you'll need to replace these with your actual keys)
// For development, you can use test keys from Google
const RECAPTCHA_CONFIG = {
  // Test keys for development (these are Google's test keys)
  siteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
  secretKey: process.env.REACT_APP_RECAPTCHA_SECRET_KEY || '6LeIxAcTAAAAAGG-vFI1TnRWxMZNFuojJ4WifJWe',
  
  // Production keys (replace with your actual keys)
  // siteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
  // secretKey: process.env.REACT_APP_RECAPTCHA_SECRET_KEY,
  
  // reCAPTCHA settings
  theme: 'light', // 'light' or 'dark'
  size: 'normal', // 'normal', 'compact', or 'invisible'
  type: 'image', // 'image' or 'audio'
};

export default RECAPTCHA_CONFIG;
